import MuiCollapse, { type CollapseProps } from "@mui/material/Collapse";

export type { CollapseProps };

export function Collapse(props: CollapseProps) {
  return <MuiCollapse {...props} />;
}
